import Axios from "axios";
import { backendUrl, getAuthHeaders } from "../utils/api";

const handleResponse = (promise) => {
  return promise
    .then((response) => response.data)
    .catch((error) => {
      if (error.response && error.response.data) {
        const data = error.response.data;
        const msg = data.detail || (data.non_field_errors && data.non_field_errors[0]) || data.message || JSON.stringify(data);
        const err = new Error(msg);
        err.status = error.response.status;
        throw err;
      }
      throw error;
    });
};

const authApi = {
  login(email, password) {
    return handleResponse(
      Axios({
        url: `${backendUrl}/auth/login`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: { email, password },
      })
    );
  },
  exchangeTempToken(tempToken) {
    return handleResponse(
      Axios({
        url: `${backendUrl}/auth/external/exchange-token`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: { temp_token: tempToken },
      })
    );
  },

  getMe() {
    return handleResponse(
      Axios({
        url: `${backendUrl}/auth/me`,
        method: "GET",
        headers: getAuthHeaders(),
      })
    );
  },

  getClients() {
    return handleResponse(
      Axios({
        url: `${backendUrl}/auth/clients`,
        method: "GET",
        headers: getAuthHeaders(),
      })
    );
  },

  createClient(name) {
    return handleResponse(
      Axios({
        url: `${backendUrl}/auth/clients`,
        method: "POST",
        headers: getAuthHeaders(),
        data: { name },
      })
    );
  },

  updateClient(id, name) {
    return handleResponse(
      Axios({
        url: `${backendUrl}/auth/clients/${id}`,
        method: "PATCH",
        headers: getAuthHeaders(),
        data: { name },
      })
    );
  },

  deleteClient(id) {
    return handleResponse(
      Axios({
        url: `${backendUrl}/auth/clients/${id}`,
        method: "DELETE",
        headers: getAuthHeaders(),
      })
    );
  },

  getUsers() {
    return handleResponse(
      Axios({
        url: `${backendUrl}/auth/users`,
        method: "GET",
        headers: getAuthHeaders(),
      })
    );
  },

  createUser(payload) {
    return handleResponse(
      Axios({
        url: `${backendUrl}/auth/users`,
        method: "POST",
        headers: getAuthHeaders(),
        data: payload,
      })
    );
  },

  updateUser(id, payload) {
    return handleResponse(
      Axios({
        url: `${backendUrl}/auth/users/${id}`,
        method: "PATCH",
        headers: getAuthHeaders(),
        data: payload,
      })
    );
  },

  deleteUser(id) {
    return handleResponse(
      Axios({
        url: `${backendUrl}/auth/users/${id}`,
        method: "DELETE",
        headers: getAuthHeaders(),
      })
    );
  },
};

export default authApi;
